export default {
    messageManagement: 'จัดการข้อความ'
}
